import j, { forwardRef as _, useRef as m, useEffect as l } from "react";
import { Chart as k } from "./index.es161.js";
const b = "label";
function h(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function x(t, e) {
  const a = t.options;
  a && e && Object.assign(a, e);
}
function w(t, e) {
  t.labels = e;
}
function y(t, e) {
  let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : b;
  const o = [];
  t.datasets = e.map((r) => {
    const s = t.datasets.find((i) => i[a] === r[a]);
    return !s || !r.data || o.includes(s) ? {
      ...r
    } : (o.push(s), Object.assign(s, r), s);
  });
}
function E(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
  const a = {
    labels: [],
    datasets: []
  };
  return w(a, t.labels), y(a, t.datasets, e), a;
}
function I(t, e) {
  const { height: a = 150, width: o = 300, redraw: r = !1, datasetIdKey: s, type: i, data: u, options: c, plugins: v = [], fallbackContent: C, updateMode: p, ...R } = t, d = m(null), n = m(null), f = () => {
    d.current && (n.current = new k(d.current, {
      type: i,
      data: E(u, s),
      options: c && {
        ...c
      },
      plugins: v
    }), h(e, n.current));
  }, g = () => {
    h(e, null), n.current && (n.current.destroy(), n.current = null);
  };
  return l(() => {
    !r && n.current && c && x(n.current, c);
  }, [
    r,
    c
  ]), l(() => {
    !r && n.current && w(n.current.config.data, u.labels);
  }, [
    r,
    u.labels
  ]), l(() => {
    !r && n.current && u.datasets && y(n.current.config.data, u.datasets, s);
  }, [
    r,
    u.datasets
  ]), l(() => {
    n.current && (r ? (g(), setTimeout(f)) : n.current.update(p));
  }, [
    r,
    c,
    u.labels,
    u.datasets,
    p
  ]), l(() => {
    n.current && (g(), setTimeout(f));
  }, [
    i
  ]), l(() => (f(), () => g()), []), /* @__PURE__ */ j.createElement("canvas", {
    ref: d,
    role: "img",
    height: a,
    width: o,
    ...R
  }, C);
}
const K = /* @__PURE__ */ _(I);
export {
  K as Chart
};
//# sourceMappingURL=index.es162.js.map
